<template>
  <Modal :id="'cmp-free-dates'" @cancelled="onCancelClick">
    <template slot="header">{{ $t("available_artists") }}</template>
    <template slot="body">
      <TextField
        :id="'date'"
        class="m1"
        v-bind="textFieldConfig"
        type="date"
        :value="avDate"
        :placeholder="$t('start_date')"
        @valuechanged="onTextFieldValueChange"
      />
      <table v-if="!loading" class="dt-table2 contact-table">
        <thead class="dt-table2--head">
          <tr
            class="dt-table2--row"
            :style="{
              'margin-right': hRowMarginRight,
            }"
          >
            <th class="dt-table2--column">{{ $t("artist_name") }}</th>

            <th class="dt-table2--column">{{ $t("url1") }}</th>
          </tr>
        </thead>
        <tbody class="dt-table2--body" style="min-height: 380px">
          <tr
            class="dt-table2--row"
            v-for="(artist, index) in artists"
            :key="index"
            @click="(e) => onArtistClick(artist)"
            style="cursor: copy"
          >
            <td class="dt-table2--column" :title="getArtistName(artist)">
              <div class="txtov">
                {{ getArtistName(artist) }}
              </div>
            </td>
            <td class="dt-table2--column">{{ artist["url1"] }}</td>
          </tr>
        </tbody>
      </table>
      <LoadingTextUI
        v-else
        height="410px"
        :text="'Loading Available Artists'"
      />
    </template>
    <template slot="options">
      <button class="dt-button s6" @click="onCancelClick">{{$t('close')}}</button>
      <button class="dt-button s6 v1" @click="onCopyClick"> {{$t('copy')}} </button>
    </template>
  </Modal>
</template>

<script>
import { getDefaultDateString } from "../../../utility/calendar";
import Modal from "../../../dt-plugins/modal/modal";
import { BookingService } from "../services/booking-service";
import { LoadingTextUI } from "../../../plugins/loading/loading-helper";
import { copyToClipboard } from "../../../dt-plugins/clipboard/clipboard";

export default {
  components: {
    Modal,
    LoadingTextUI,
  },
  data: function () {
    return {
      date: getDefaultDateString(new Date()),
      loading: false,
      artists: [],
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: false,
        isModel: true,
      },
      // Mark: Data
    };
  },
  mounted: function () {
    this.fetchAvailableArtists();
  },
  computed: {
    hRowMarginRight: function () {
      if (this.artists.length > 380 / 28) {
        return "28px";
      }
    },
    avDate() {
      if (this.$route.query.date) {
        return this.$route.query.date;
      } else {
        return getDefaultDateString(new Date());
      }
    },
  },
  methods: {
    onTextFieldValueChange: async function (name, value) {
      console.log({ "name, value": name, value });

      // this.date = value;

      this.$router.push({
        ...this.$route,
        query: {
          ...this.$route.query,
          date: value,
        },
      });

      this.fetchAvailableArtists();
    },
    async fetchAvailableArtists() {
      this.loading = true;
      const artists = await BookingService.findAvailableArtists({
        start_date: this.avDate,
      });

      this.artists = artists.data || [];
      console.log("this.artists",this.artists?.map(this.getArtistName));      
      this.loading = false;
    },
    getArtistName(artist) {
      return `${artist["artist_name"]}${
        artist["booking_status_name"]
          ? `(${artist["booking_status_name"]}, ${artist["booking_location_name"]}, ${artist["city"]}), `
          : ","
      } ${artist["performance_type"]}`;
    },
    onCancelClick: function (event) {
      this.$emit("cancelled", true);
    },
    onArtistClick(artist) {
      copyToClipboard(`${this.getArtistName(artist)} ${artist["url1"]}`);
    },
    onCopyClick() {
      copyToClipboard(
        this.artists
          ?.map((artist) => `${this.getArtistName(artist)} ${artist["url1"]}`)
          .join("\n")
      );
    },
    // Mark: Methods
  },
};
</script>

<style lang="scss" scoped>
.dt-table2 {
  th:nth-child(1),
  td:nth-child(1) {
    min-width: 300px;
  }
}
</style>
